module.exports = __webpack_public_path__ + "static/img/1-1.1174797.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/2/1-1.png
// module id = L1Ze
// module chunks = 0